import { StyledRoot, StyledContentWrapper } from "./FormShell.styles"

/**
 * CMS-driven recipient lists must contain 1–3 emails each (no CRM yet — the
 * frontend ships the list to the backend). Returns true only when every list
 * is within range.
 */
export function validateRecipients(...lists: string[][]): boolean {
  return lists.every((list) => list.length >= 1 && list.length <= 3)
}

/**
 * Rendered in place of a form when its CMS recipients are misconfigured.
 * Visible only in development so editors/devs notice; renders nothing in
 * production to avoid leaking config errors to end users.
 */
export function RecipientsConfigError({ formName }: { formName: string }) {
  if (process.env.NODE_ENV !== "development") return null
  return (
    <StyledRoot>
      <StyledContentWrapper>
        <div style={{ padding: 16, color: "red" }}>
          {formName}: invalid recipients configuration (need 1–3 email
          addresses).
        </div>
      </StyledContentWrapper>
    </StyledRoot>
  )
}
